export const TWO_YEAR_UPFRONT_KEY = 'TWO_YEAR_UPFRONT'



// WEBPACK FOOTER //
// ./src/constants/registration/discountKeys.js